// @flow
import type { BoardSortOptionsType } from 'app/packages/pinterest-flow-types/user';
import { profileBoardsFeedId } from 'app/common/redux/selectors/profileBoards';
import invalidateFeed, { type FeedInvalidate } from 'app/common/redux/actions/feeds/invalidate';
import {
  resourceInvalidate,
  type ResourceInvalidate,
} from 'app/common/redux/actions/resourceFetch';

export const BOARD_SORT_OPTIONS: Array<BoardSortOptionsType> = [
  'alphabetical',
  'last_pinned_to',
  'oldest',
  'newest',
  'custom',
];

const PROFILE_BOARDS_RESOURCE_PAGE_SIZE = 25;

type Props = { boardOrder?: BoardSortOptionsType, mixPublicSecret?: boolean, username: string };

export const profileBoardsResource = {
  name: 'BoardsResource',
  key: 'boardsResource',
  options: ({ boardOrder, mixPublicSecret, username }: Props) => ({
    privacy_filter: 'all',
    sort: boardOrder || 'last_pinned_to',
    field_set_key: 'profile_grid_item',
    username,
    page_size: PROFILE_BOARDS_RESOURCE_PAGE_SIZE,
    group_by: mixPublicSecret ? 'mix_public_private' : 'visibility',
    include_archived: true,
    redux_normalize_feed: true,
  }),
};

export const getBoardsResourceOptions = (
  username: string,
  isPrivate: boolean,
  sort?: BoardSortOptionsType,
) => ({
  privacy_filter: isPrivate ? 'secret' : 'public',
  sort: sort || 'last_pinned_to',
  field_set_key: 'profile_grid_item',
  username,
});

type ProfileBoardsFeedInvalidate = FeedInvalidate | ResourceInvalidate;

export const ownProfileBoardsResourceInvalidates = (
  username: string,
): Array<ProfileBoardsFeedInvalidate> =>
  BOARD_SORT_OPTIONS.reduce(
    (actions: Array<ProfileBoardsFeedInvalidate>, boardOrder: BoardSortOptionsType) => {
      // HACK(jackhsu): brute force all possible board sort options
      const additionalActions = [
        invalidateFeed('profileBoards', profileBoardsFeedId(username, boardOrder)),
      ];
      [true, false].forEach((mixPublicSecret) => {
        additionalActions.push(
          resourceInvalidate(
            profileBoardsResource.name,
            profileBoardsResource.options({ username, boardOrder, mixPublicSecret }),
          ),
        );
      });
      return actions.concat(additionalActions);
    },
    [],
  );
